// extracted by mini-css-extract-plugin
export var headerCell = "_5n-1";
export var loadingSpinnerContainer = "_5n-4";
export var loadingStateCell = "_5n-5";
export var rowWrapper = "_5n-3";
export var standaloneTable = "_5n-6";
export var table = "_5n-0";
export var white = "_5n-2";